export enum EachCurrentCollision {
    AreSame,
    AreDifferent,
}
